module.exports = __webpack_public_path__ + "img/icon2.d5c73056.png";